import { MemberStatementCoverage } from './useStatementCoverage.interface';

import collectiveApi from 'modules/common/collectiveApi';

const PATH = 'bookkeeping/v2/bank-statements/coverage/';

export default async function fetchStatementCoverage(memberId: number): Promise<MemberStatementCoverage> {
    const { data } = await collectiveApi.get<MemberStatementCoverage>(PATH, {
        params: { member_id: memberId },
    });
    return data;
}
